import React from 'react';
import { Button, Container } from '@mui/material';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import { Footer } from './Footer';

const HeaderLayout = styled.header`
  padding: 1rem 0;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: space-between;

  img {
    max-height: 48px;
  }
`;
const LayoutUnloggedContainer = styled.section`
  min-height: calc(100vh - 352px);
`;

export const LayoutUnlogged = (props) => {
  const navigate = useNavigate();
  return (
    <>
      <Container>
        <HeaderLayout>
          <img src={process.env.REACT_APP_APP_URL + "images/eskala.svg"} alt="Eskala" className='button-text' onClick={ () => navigate('/')} />
          <Button
            variant='outlined'
            size='small'
            onClick={ () => navigate('/')}
            className='bold-text dark--text dark--border'
          >
            Home
          </Button>
        </HeaderLayout>
      </Container>
      <LayoutUnloggedContainer>
        {props.children}
      </LayoutUnloggedContainer>
      <Footer />
    </>
  )
}
